'use strict';

var promisify = require('promisify-es6');

var _require = require('./utils'),
    createLock = _require.createLock; // These operations are read-locked at the function level and will execute simultaneously


var readOperations = {
  ls: require('./ls'),
  stat: require('./stat') // These operations are locked at the function level and will execute in series

};
var writeOperations = {
  cp: require('./cp'),
  flush: require('./flush'),
  mkdir: require('./mkdir'),
  mv: require('./mv'),
  rm: require('./rm') // These operations are asynchronous and manage their own locking

};
var unwrappedOperations = {
  write: require('./write'),
  read: require('./read') // These operations are synchronous and manage their own locking

};
var unwrappedSynchronousOperations = {
  readPullStream: require('./read-pull-stream'),
  readReadableStream: require('./read-readable-stream')
};

var wrap = function wrap(_ref) {
  var ipfs = _ref.ipfs,
      mfs = _ref.mfs,
      operations = _ref.operations,
      lock = _ref.lock;
  Object.keys(operations).forEach(function (key) {
    mfs[key] = promisify(lock(operations[key](ipfs)));
  });
};

var defaultOptions = {
  repoOwner: true
};

module.exports = function (ipfs, options) {
  var _Object$assign = Object.assign({}, defaultOptions || {}, options),
      repoOwner = _Object$assign.repoOwner;

  var lock = createLock(repoOwner);

  var readLock = function readLock(operation) {
    return lock.readLock(operation);
  };

  var writeLock = function writeLock(operation) {
    return lock.writeLock(operation);
  };

  var mfs = {};
  wrap({
    ipfs: ipfs,
    mfs: mfs,
    operations: readOperations,
    lock: readLock
  });
  wrap({
    ipfs: ipfs,
    mfs: mfs,
    operations: writeOperations,
    lock: writeLock
  });
  Object.keys(unwrappedOperations).forEach(function (key) {
    mfs[key] = promisify(unwrappedOperations[key](ipfs));
  });
  Object.keys(unwrappedSynchronousOperations).forEach(function (key) {
    mfs[key] = unwrappedSynchronousOperations[key](ipfs);
  });
  return mfs;
};